import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMonitoring = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.3 21.5C6.9 21.5 6.5 21.2 6.4 20.8L3.2 12H1C0.4 12 0 11.6 0 11C0 10.4 0.4 10 1 10H3.9C4.3 10 4.7 10.3 4.8 10.7L7.3 17.5L13 0.7C13.1 0.3 13.5 0 13.9 0C14.3 0 14.7 0.3 14.8 0.7L17.8 10.1H20.4C21 10.1 21.4 10.5 21.4 11.1C21.4 11.7 21 12.1 20.4 12.1H17C16.6 12.1 16.2 11.8 16 11.4L13.7 4.2L8.2 20.8C8.1 21.2 7.7 21.5 7.3 21.5Z",
		fill: "white"
	})
});
export default SvgMonitoring;
